// extracted by mini-css-extract-plugin
module.exports = {"container":"_93444fe79c--container--JY8PT","full-width":"_93444fe79c--full-width--tqOX6","list":"_93444fe79c--list--gif_Q"};